import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Shipment,
  ShipmentMetrics,
  CreateShipmentRequest,
  UpdateShipmentRequest,
  AssignBoxesRequest,
  ShipmentsListParams,
  ShipmentStatus
} from '../types';

const { SHIPMENTS } = API_ENDPOINTS;

export const shippingApi = {
  getAll: (params?: ShipmentsListParams) =>
    apiClient.getPaginated<Shipment>(SHIPMENTS.LIST, params),

  getById: (id: number) => apiClient.get<Shipment>(SHIPMENTS.GET(id)),

  create: (data: CreateShipmentRequest) =>
    apiClient.post<Shipment>(SHIPMENTS.CREATE, data),

  update: (id: number, data: UpdateShipmentRequest) =>
    apiClient.put<Shipment>(SHIPMENTS.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(SHIPMENTS.DELETE(id)),

  changeStatus: (id: number, status: ShipmentStatus) =>
    apiClient.patch<Shipment>(SHIPMENTS.CHANGE_STATUS(id), { status }),

  assignBoxes: (id: number, data: AssignBoxesRequest) =>
    apiClient.post<Shipment>(SHIPMENTS.ASSIGN(id), data),

  confirm: (id: number) => apiClient.post<Shipment>(SHIPMENTS.CONFIRM(id)),

  dispatch: (id: number) => apiClient.post<Shipment>(SHIPMENTS.DISPATCH(id)),

  saveDraft: (data: CreateShipmentRequest) =>
    apiClient.post<Shipment>(SHIPMENTS.SAVE_DRAFT, data),

  getMetrics: () => apiClient.get<ShipmentMetrics>(SHIPMENTS.METRICS),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<ShipmentsListParams> }
  ) => apiClient.post(SHIPMENTS.BULK_DELETE, params),

  bulkChangeStatus: (
    params:
      | { ids: number[]; status: ShipmentStatus }
      | {
          all: true;
          filters: Partial<ShipmentsListParams>;
          status: ShipmentStatus;
        }
  ) => apiClient.post(SHIPMENTS.BULK_CHANGE_STATUS, params)
};
